import dayjs from 'dayjs';
import { logger } from 'logging-utils';
import { ApiKeyRoleType, ApiKeyStatus } from '../types/api-key-types';

export const apiKeyTypeMap: Record<ApiKeyRoleType, string> = {
  CICDIntegration: 'CI/CD Integration',
  APIIntegration: 'API Integration',
};

export const apiKeyStatusColorMap: Record<
  ApiKeyStatus,
  'success' | 'error' | 'warning'
> = {
  Active: 'success',
  Expired: 'error',
  Disabled: 'warning',
};

export const apiKeyStatusToSetMap: Record<ApiKeyStatus, ApiKeyStatus> = {
  Active: ApiKeyStatus.Disabled,
  Disabled: ApiKeyStatus.Active,
  Expired: ApiKeyStatus.Disabled,
};

export const apiKeyStatusToSetActionMap: Record<ApiKeyStatus, string> = {
  Active: 'Enable',
  Disabled: 'Disable',
  Expired: 'Disable',
};

export const apiKeyStatusToSetColorMap: Record<
  ApiKeyStatus,
  'success' | 'error'
> = {
  Active: 'success',
  Expired: 'error',
  Disabled: 'error',
};

export const getExpirationTimeSec = (date: dayjs.Dayjs) => {
  try {
    return Math.round(date.diff(dayjs(Date.now())) / 1000);
  } catch (error) {
    logger.error('Failed to get expiration date, fallback to 24h', error);
    return 24 * 60 * 60;
  }
};
